// landing/src/screens/SuccessScreen.jsx

const C = { bg: '#1c1c1c', surface: '#2a2a2a', orange: '#ff7a00', muted: '#888', text: '#fff' };

export default function SuccessScreen({ result }) {
  const loginUrl = result.login_url || `https://serveiq.co.ke/v/${result.slug}`;

  const copyLink = () => {
    navigator.clipboard.writeText(loginUrl).catch(() => {});
  };

  const openApp = () => {
    window.location.href = loginUrl;
  };

  return (
    <div style={s.page}>
      <div style={s.container}>

        <h1 style={s.logo}>ServeIQ</h1>

        <div style={s.checkmark}>✓</div>

        <h2 style={s.heading}>You're live!</h2>
        <p style={s.sub}>
          <strong style={{ color: '#fff' }}>{result.venue_name}</strong> has been set up.
          Check your WhatsApp for your sign-in details.
        </p>

        <div style={s.linkBox}>
          <p style={s.linkLabel}>YOUR VENUE LOGIN LINK</p>
          <p style={s.linkText}>{loginUrl}</p>
        </div>

        <button style={s.primaryBtn} onClick={openApp}>
          OPEN MY POS
        </button>

        <button style={s.secondaryBtn} onClick={copyLink}>
          COPY LINK
        </button>

        <p style={s.note}>
          Bookmark this link or save it to your home screen.
          Share it with your staff so they can sign in.
        </p>

      </div>
    </div>
  );
}

const s = {
  page:        { minHeight: '100vh', backgroundColor: C.bg, display: 'flex',
                 alignItems: 'center', justifyContent: 'center', padding: '32px 16px' },
  container:   { maxWidth: 400, width: '100%', textAlign: 'center' },

  logo:        { color: C.orange, fontSize: 42, fontWeight: 700, letterSpacing: 2, marginBottom: 24 },
  checkmark:   { width: 72, height: 72, borderRadius: '50%', background: '#2a6b2a',
                 color: '#fff', fontSize: 36, display: 'flex', alignItems: 'center',
                 justifyContent: 'center', margin: '0 auto 24px' },
  heading:     { color: '#fff', fontSize: 32, fontWeight: 700, marginBottom: 8 },
  sub:         { color: C.muted, fontSize: 15, marginBottom: 28, lineHeight: 1.5 },

  linkBox:     { background: C.surface, borderRadius: 10, padding: '16px 20px',
                 marginBottom: 20, border: '1px solid #333' },
  linkLabel:   { color: C.orange, fontSize: 11, fontWeight: 700, letterSpacing: 2,
                 marginBottom: 8 },
  linkText:    { color: '#fff', fontSize: 14, wordBreak: 'break-all', lineHeight: 1.4 },

  primaryBtn:  { width: '100%', padding: '16px 0', background: C.orange, border: 'none',
                 borderRadius: 10, color: '#fff', fontSize: 20, fontWeight: 700,
                 cursor: 'pointer', letterSpacing: 1, marginBottom: 12,
                 fontFamily: "'Barlow Condensed', sans-serif" },
  secondaryBtn:{ width: '100%', padding: '14px 0', background: 'transparent',
                 border: `2px solid ${C.orange}`, borderRadius: 10, color: C.orange,
                 fontSize: 18, fontWeight: 700, cursor: 'pointer', letterSpacing: 1,
                 marginBottom: 24, fontFamily: "'Barlow Condensed', sans-serif" },

  note:        { color: '#555', fontSize: 13, lineHeight: 1.5 },
};
